export default __webpack_public_path__ + "static/media/logo.85e905b7.png";